import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { white } from '../../../theme';
import hexToRgb from '../../../helpers/ui/coloringHelper';
import { PALETTE_COLOR_TYPES } from '../../../constants';

export const MAIN_BUTTON_WIDTH_KEYS = {
  EXTRA_LARGE: 'extraLarge',
  FULL_WIDTH: 'fullWidth',
};

const MainButton = withStyles((theme) => ({
  root: {
    alignItems: 'center',
    borderRadius: '0.5rem',
    boxShadow: 'none',
    textTransform: 'uppercase',

    fontSize: (props) => {
      const sizeByProps = {
        small: '0.8rem',
        medium: '1.125rem',
        large: '1.25rem',
      };
      return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : '1.125rem';
    },
    height: (props) => {
      const sizeByProps = {
        small: '2rem',
        medium: '3.5rem',
        large: '4rem',
      };
      return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : '3.5rem';
    },
    width: (props) => {
      const sizeByProps = {
        small: '8rem',
        medium: '14rem',
        large: '16rem',
      };
      const widthProps = {
        extraLarge: '23rem',
        fullWidth: '100%',
      };

      if (props.width) {
        return widthProps[props.width];
      }
      return props.size && sizeByProps[props.size] ? sizeByProps[props.size] : sizeByProps.medium;
    },
    color: (props) => {
      const color = {
        outlined: theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
        contained: theme.palette.white.main,
        text: theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
      };

      return color[props.variant];
    },
    backgroundColor: (props) => {
      const bgColor = {
        contained: theme.palette[props.color].main,
        outlined: 'transparent',
        text: 'transparent',
      };

      return bgColor[props.variant];
    },
    border: (props) => {
      const border = {
        outlined: `1px solid ${theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main}`,
        contained: 'none',
        text: 'none',
      };

      return border[props.variant];
    },
    '@media (max-width: 1283px)': {
      '&:hover': {
        backgroundColor: (props) => {
          const bgColor = {
            contained: theme.palette[props.color].main,
            outlined: 'transparent',
            text: 'transparent',
          };

          return bgColor[props.variant];
        },
        color: (props) => {
          const color = {
            text: theme.palette[props.color].pressed,
            contained: white,
            outlined: theme.palette[props.color].main,
          };
          return color[props.variant];
        },
      },
    },
    '@media (min-width: 1283px)': {
      '&:hover': {
        backgroundColor: (props) => {
          const bgColor = {
            contained: theme.palette[props.color].hover,
            outlined: `rgba(${hexToRgb(theme.palette[props.color].main)}, 0.1)`,
            text: theme.palette.white.efesBackgroundLight,
          };

          return bgColor[props.variant];
        },
        border: (props) => {
          const border = {
            contained: 'none',
            outlined: 'none',
            text: 'none',
          };
          return border[props.variant];
        },
        color: (props) => {
          const color = {
            text: theme.palette[props.color].pressed,
            contained: white,
            outlined: theme.palette[props.color].main,
          };

          return color[props.variant];
        },
      },
    },
    '&:active': {
      backgroundColor: (props) => {
        const bgColor = {
          contained: theme.palette[props.color].pressed,
          outlined: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.4)`,
          text: 'transparent',
        };

        return bgColor[props.variant];
      },
      color: (props) => {
        const color = {
          text: theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
        };

        return color[props.variant];
      },
      border: (props) => {
        const bgColorByVariant = {
          contained: 'none',
          outlined: 'none',
          text: 'none',
        };

        return bgColorByVariant[props.variant];
      },
      fontWeight: (props) => {
        const bgColorByVariant = {
          text: 'bold',
        };

        return bgColorByVariant[props.variant];
      },
    },
    '&:disabled': {
      backgroundColor: (props) => {
        const bgColorByVariant = {
          outlined: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.1)`,
          contained: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.2)`,
          text: 'transparent',
        };

        const bgColorByColor = {
          contained: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.5)`,
          outlined: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.1)`,
        };

        if (props.color) {
          return bgColorByColor[props.variant];
        }

        return bgColorByVariant[props.variant];
      },
      color: (props) => {
        const colorByVariant = {
          outlined: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.6)`,
          contained: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.6)`,
          text: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.5)`,
        };

        const colorByColor = {
          contained: theme.palette.white.main,
          outlined: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.6)`,
          text: `rgba(${hexToRgb(
            theme.palette[props.color || PALETTE_COLOR_TYPES.PRIMARY].main,
          )}, 0.5)`,
        };

        if (props.color) {
          return colorByColor[props.variant];
        }

        return colorByVariant[props.variant];
      },
      border: (props) => {
        const bgColorByVariant = {
          contained: 'none',
          outlined: 'none',
          text: 'none',
        };

        return bgColorByVariant[props.variant];
      },
    },
  },
}))(Button);

export default MainButton;
